import { ActionsColumn, Delimiter, Typography } from '@otp/ui';
import { formatDate } from '@otp/utils';
import { Alert } from '@otp/icons';
import { MostHistoryTable } from 'src/components/most/list/history/item/suggested-tasks/table';
import { ResultData } from 'src/components/most/list/history/item/result-data';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';
import { PartialMostRequestHistoryType } from 'src/components/most/list/history/types';
import { AddToFavorites } from 'src/components/most/common/add-to-favorites';
import { getValuesFromRequestHistory } from 'src/components/most/common/task-helpers';
import {
  MostFavouriteByJobConfigExactMatchDocument,
  MostFavouritesDocument,
} from 'src/graphql/generated/graphql';
import { useQuery } from '@apollo/client';

interface HistoryItemProps {
  item: PartialMostRequestHistoryType;
}

export const RequestHistoryItem = ({ item }: HistoryItemProps) => {
  const { t } = useTranslation();
  const isTriage = !!item.triageId;

  const actions = [
    {
      icon: (
        <AddToFavorites
          defaultValue={getValuesFromRequestHistory(item)}
          refetchQueries={[
            MostFavouritesDocument,
            MostFavouriteByJobConfigExactMatchDocument,
          ]}
          checkIfIsFavourited
        />
      ),
    },
  ];

  return (
    <div className="w-full">
      <div className="flex justify-between items-end">
        <div>
          <Typography className={styles.title}>
            {item.queryName || item.triageName}
          </Typography>
          <Typography className={styles.date}>
            {formatDate(item.completedOn, 'M/d/yyyy h:mm:ss a')}
          </Typography>
        </div>
        <ActionsColumn icons={actions} />
      </div>

      <Delimiter className="mt-1" />

      {item.suggestedTasks?.length > 0 && (
        <div className="mt-4">
          <Typography className={styles.alertsTitle}>
            <Alert className="scale-75 mr-1" />{' '}
            {t('most.history-details.alerts-available-actions')}
          </Typography>
          <div className="mt-3">
            <MostHistoryTable
              data={item.suggestedTasks}
              store={item.store as { id: string; nationalStoreNumber: string }}
              options={{
                page: 1,
                count: item.suggestedTasks.length,
                rowsPerPage: item.suggestedTasks.length,
                enableNestedDataAccess: '.',
              }}
            />
          </div>
        </div>
      )}

      <div className="mt-4">
        <Typography className={styles.resultDataTitle}>
          <Alert className="scale-75 mr-1" />{' '}
          {t(
            `most.history-details.${
              isTriage ? 'triage' : 'query'
            }-results-detail-data`,
          )}
        </Typography>
        {item.resultDataWithProblems && (
          <div className="mt-3">
            <ResultData data={item.resultDataWithProblems} />
          </div>
        )}
      </div>
    </div>
  );
};
